/*
  EditorView
  The form and document editor where forms are created and documents are mapped
*/

import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ApplicationService } from '@state/application';
import { DocumentService, FormService as FormLegacyService } from '@app/shared/services';
import { Form, FormService } from '@state/form';
import { ID } from '@state/base';
import { User, UserQuery } from '@app/state/user';
import { WorkspaceType } from '@app/shared/components/workspace/workspace.component';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'fl-editor-view',
  styleUrls: ['./editor-view.component.scss'],
  templateUrl: './editor-view.component.html'
})
export class EditorViewComponent implements OnInit {
  private id: string;

  loadedAnyData = false;
  workspaceContext: string;
  workspaceType: WorkspaceType;

  constructor(
    private activatedRoute: ActivatedRoute,
    private applicationService: ApplicationService,
    private formService: FormService,
    private router: Router,
    public documentService: DocumentService,
    public formLegacyService: FormLegacyService,
    public userQuery: UserQuery
  ) {}

  ngOnInit() {
    this.activatedRoute.data.subscribe({
      next: (data) => {
        this.workspaceType = data.type;
        this.workspaceContext = `${this.workspaceType}Workspace`;
      }
    });

    this.activatedRoute.params.subscribe({
      next: (params) => {
        this.id = params.id;

        switch (this.workspaceType) {
          case WorkspaceType.Document:
            if (this.user.doc_admin) {
              this.getDocument(this.id);
            } else {
              void this.router.navigate(['view'], {
                relativeTo: this.activatedRoute,
                skipLocationChange: false
              });
            }
            break;

          case WorkspaceType.Form:
          case WorkspaceType.Rtd:
            if (this.user.doc_admin) {
              this.getForm(this.id);
            } else {
              void this.router.navigate(['preview'], {
                relativeTo: this.activatedRoute,
                skipLocationChange: false
              });
            }
            break;
        }
      }
    });
  }

  get user(): User {
    return this.userQuery.getValue().user;
  }

  getForm(id: string, suppressNestedCall = false): void {
    this.applicationService.pushLoading('editor-view/form');
    this.formLegacyService.getForm(id, {
      success: (form: Form) => {
        let documentId = form.document_id;
        this.applicationService.popLoading('editor-view/form');
        this.loadedAnyData = true;
        this.formService.setform(form);

        if (documentId && !suppressNestedCall) {
          this.getDocument(documentId, true);
        }
      }
    });
  }

  getDocument(id: ID, suppressNestedCall = false): void {
    this.applicationService.pushLoading('editor-view/form');
    this.documentService.getDocument$(id, {
      success: (data) => {
        this.applicationService.popLoading('editor-view/form');
        this.loadedAnyData = true;
        if (data.form_id && !suppressNestedCall) {
          let formId: string = data.form_id;
          this.getForm(formId, true);
        }
      }
    });
  }

  onSetWorkspaceType(type: WorkspaceType): void {
    this.workspaceType = type;
  }
}
